<template>
  <div class="sp_view">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="聊天" name="chat">
        <EnterChat ref="EnterChat" />
      </el-tab-pane>
      <el-tab-pane label="审批" name="approval" lazy>
        <Approval ref="Approval" />
      </el-tab-pane>
      <!-- <el-tab-pane label="汇报" name="report" lazy>
        <Report ref="Report" />
      </el-tab-pane> -->
      <el-tab-pane label="好友" name="addFriends"><addFriends /></el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import EnterChat from './EnterChat.vue'
import addFriends from './addFriends.vue'
export default {
  name: 'Paging',
  components: {
    EnterChat,
    addFriends,
    Approval: () => import('./Approval.vue')
    // Report: () => import('./report.vue')
  },
  data() {
    return {
      activeName: 'chat'
    }
  },
  created() {

  },
  mounted() {
  },
  activated() {

  },
  methods: {
    handleClick(e) {
      // console.log(e.index, '111------')
      // if (e.index === '0') {
      //   console.log(0)
      // } else if (e.index === '1') {
      //   this.$refs.Approval.getdatalist()
      // } else if (e.index === '2') {
      //   console.log(2)
      // }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding: 30px;
}
.el-tab-pane{
  margin-top:20px ;
}
::v-deep .el-tabs--border-card > .el-tabs__content {
  margin-bottom: 50%;
}
</style>
